<template>
  <v-dialog
    v-model="show"
    fullscreen
    transition="dialog-bottom-transition"
    hide-overlay
  >
    <v-card>
      <Toolbar
        title="Tevékenységek"
        :show-btn="false"
        :btn-disabled="true"
        @close="reset"
      />

      <v-card-text class="pt-3">
        <v-simple-table>
          <thead>
            <tr>
              <th class="v-data-table__divider">Mező</th>
              <th class="v-data-table__divider">Régi érték</th>
              <th>Új érték</th>
            </tr>
          </thead>

          <tbody>
            <tr
              v-for="attribute in Object.keys(activity.changes.attributes)"
              :key="$_.uniqueId(attribute)"
            >
              <th class="v-data-table__divider">
                {{ $t(attribute) }}
              </th>
              <td class="v-data-table__divider">
                {{
                  activity.changes.old ? activity.changes.old[attribute] : "-"
                }}
              </td>
              <td>
                {{ activity.changes.attributes[attribute] }}
              </td>
            </tr>
          </tbody>
        </v-simple-table>
      </v-card-text>
    </v-card>
  </v-dialog>
</template>

<script>
import { mapActions, mapGetters } from "vuex";
export default {
  name: "ActivitiesModal",
  computed: {
    ...mapGetters("Modal", {
      show: "showActivitiesModal"
    }),
    ...mapGetters("Activity", ["activity"])
  },
  methods: {
    ...mapActions(["reset"])
  }
};
</script>

<style></style>
